import { render, staticRenderFns } from "./HealthSecurity.vue?vue&type=template&id=224d974f&scoped=true&"
import script from "./HealthSecurity.vue?vue&type=script&lang=js&"
export * from "./HealthSecurity.vue?vue&type=script&lang=js&"
import style0 from "./HealthSecurity.vue?vue&type=style&index=0&id=224d974f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224d974f",
  null
  
)

export default component.exports